/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerView } from './';
import {
    FreelancerViewFromJSON,
    FreelancerViewFromJSONTyped,
    FreelancerViewToJSON,
} from './';

/**
 * 
 * @export
 * @interface InvitationFreelancers
 */
export interface InvitationFreelancers {
    /**
     * 
     * @type {Array<FreelancerView>}
     * @memberof InvitationFreelancers
     */
    profiles: Array<FreelancerView>;
    /**
     * 
     * @type {boolean}
     * @memberof InvitationFreelancers
     */
    areFreelancersFromCompanyPool: boolean;
}

/**
 * Check if a given object implements the InvitationFreelancers interface.
 */
export function instanceOfInvitationFreelancers(value: object): value is InvitationFreelancers {
    if (!('profiles' in value) || value['profiles'] === undefined) return false;
    if (!('areFreelancersFromCompanyPool' in value) || value['areFreelancersFromCompanyPool'] === undefined) return false;
    return true;
}

export function InvitationFreelancersFromJSON(json: any): InvitationFreelancers {
    return InvitationFreelancersFromJSONTyped(json, false);
}

export function InvitationFreelancersFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvitationFreelancers {
    if (json == null) {
        return json;
    }
    return {
        
        'profiles': ((json['profiles'] as Array<any>).map(FreelancerViewFromJSON)),
        'areFreelancersFromCompanyPool': json['areFreelancersFromCompanyPool'],
    };
}

export function InvitationFreelancersToJSON(value?: InvitationFreelancers | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profiles': ((value['profiles'] as Array<any>).map((v) => FreelancerViewToJSON(v))),
        'areFreelancersFromCompanyPool': value['areFreelancersFromCompanyPool'],
    };
}

